import * as React from 'react';

import classNames from 'classnames';

import { Translate } from '@decorators';

import { IconArrowDown } from '@base/assets/icons';

import {
	CollapsibleTextBlock,
	ContentPanel,
	Icon,
} from '@components';

import * as s from './AppDescription.scss';

export interface IAppDescriptionProps {
	className?: string;
	description: string;
	isFake?: boolean;
}

@Translate('components.AppSeoPage.AppDescription')
export class AppDescription extends React.Component<IAppDescriptionProps> {

	renderExpandButton() {
		return (
			<div className={s.expandButton}>
				<span>{this.t('readAll')}</span>
				<Icon
					className={classNames(s.expandButtonIcon, s.expandButtonIconDown)}
					glyph={IconArrowDown}
				/>
			</div>
		);
	};

	renderCollapseButton() {
		return (
			<div className={s.expandButton}>
				<span>{this.t('collapse')}</span>
				<Icon
					className={classNames(s.expandButtonIcon, s.expandButtonIconUp)}
					glyph={IconArrowDown}
				/>
			</div>
		);
	};
	render() {
		const {
			className,
			description,
			isFake,
		} = this.props;
		const expandButton = this.renderExpandButton();
		const collapseButton = this.renderCollapseButton();

		return (
			<ContentPanel className={classNames(className, s.block, { [s.blockFake]: isFake })}>
				<CollapsibleTextBlock
					textClass={classNames({ [s.textFake]: isFake })}
					lineToShow={4}
					expandBtn={expandButton}
					collapseBtn={collapseButton}
					text={description}
				/>
			</ContentPanel>
		);
	}

}
